import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const LeoShape = ({
  width = 40,
  height = 40,
  fillColor = '#FFF',
  style
}: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="Horoscope" fill={fillColor}>
        <path d="M43,40H39.6a7.8,7.8,0,0,1-6.9-3.9,8,8,0,0,1-.2-7.8l4.6-8.7a12.1,12.1,0,0,0-.4-11.8A12,12,0,0,0,26.4,2H23.6A12,12,0,0,0,13.3,7.8a12.1,12.1,0,0,0-.4,11.8l1.8,3.6L13,23A10,10,0,1,0,23,33a9.8,9.8,0,0,0-1.4-5.1L16.5,17.7a8,8,0,0,1,.2-7.8A7.8,7.8,0,0,1,23.6,6h2.8a7.8,7.8,0,0,1,6.9,3.9,8,8,0,0,1,.2,7.8l-4.6,8.7a12.1,12.1,0,0,0,.4,11.8A12,12,0,0,0,39.6,44H43a2,2,0,0,0,0-4ZM13,39a6,6,0,0,1,0-12,5.8,5.8,0,0,1,5,2.8l.6,1.1h0A5.2,5.2,0,0,1,19,33,6,6,0,0,1,13,39Z" />
      </g>
    </g>
  </svg>
);

export default LeoShape;
